// ----------------------------------------------------------------------

const transitions = {
  duration: {
    shortest: 150,
    shorter: 200,
    short: 250,
    standard: 300, // Default duration for most animations
    complex: 375, // For complex animations like modals
    long: 2000,
    enteringScreen: 225,
    leavingScreen: 195,
  },
  easing: {
    easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)", // Smooth start and end
    easeOut: "cubic-bezier(0.0, 0, 0.2, 1)", // Quick start, slow end
    easeIn: "cubic-bezier(0.4, 0, 1, 1)", // Slow start, quick end
    sharp: "cubic-bezier(0.4, 0, 0.6, 1)", // Sharp transition
    modalTransition: "cubic-bezier(0.175, 0.885, 0.32, 1.275)", // Slight bounce
  },
  create: (props = ["all"], options = {}) => {
    const {
      duration = transitions.duration.standard,
      easing = transitions.easing.easeInOut,
      delay = 0,
    } = options;

    return (Array.isArray(props) ? props : [props])
      .map(prop => `${prop} ${duration}ms ${easing} ${delay}ms`)
      .join(",");
  },
};

export default transitions;
